module.exports = "<div class=row> <switch right-label=on left-label=off :value=true></switch> </div> <div class=row> <switch right-label=on left-label=off :value=false disabled=disabled></switch> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../src/demos/forms/switch-demo.vue
 ** module id = 279
 ** module chunks = 0
 **/